export { default } from './es/icons/SuccessOutlined';